import { memo, Fragment } from 'react';
import { motion } from 'motion/react';
import styles from './TextAnimator.module.css';

export const TextAnimator = memo(
  ({
    text,
    initDelay = 0,
    className,
    duration = 4,
    delay = 0.06,
    isRepeat = true,
  }) => {
    if (!text) return null;

    const words = text?.replaceAll(/\r\n/g, ' ')?.split(' ');
    let letterIndex = 0;

    const letterVariants = {
      hidden: { rotateY: -90, opacity: 0 },
      visible: isRepeat
        ? { rotateY: [-90, 0, 0, 90], opacity: [0, 1, 1, 0] }
        : { rotateY: 0, opacity: 1 },
    };

    return (
      <div className={`${styles.lettersWrapper} ${className}`}>
        {words.map((word, wi) => (
          <Fragment key={`${word}-${wi}`}>
            <span className={styles.word}>
              {word.split('').map((l) => {
                const idx = letterIndex++;
                return (
                  <motion.span
                    key={l + idx}
                    className={styles.letter}
                    variants={letterVariants}
                    initial="hidden"
                    animate="visible"
                    transition={{
                      rotateY: {
                        duration,
                        delay: delay * idx + initDelay,
                        ease: 'easeOut',
                        times: [0, 0.25, 0.75, 1],
                        repeat: isRepeat ? 1 : 0,
                        repeatDelay: isRepeat ? 0.5 : 0,
                      },
                      opacity: {
                        duration: isRepeat ? duration : 0.1,
                        delay: delay * idx + initDelay,
                        ease: 'easeOut',
                        times: isRepeat ? [0, 0.1, 0.9, 1] : [0, 1],
                        repeat: isRepeat ? 1 : 0,
                        repeatDelay: isRepeat ? 0.5 : 0,
                      },
                    }}
                  >
                    {l}
                  </motion.span>
                );
              })}
            </span>

            {wi < words.length - 1 && <span className={styles.space} />}
          </Fragment>
        ))}
      </div>
    );
  },
);
